module.exports = __webpack_public_path__ + "static/img/22.4e3fb9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/22.png
// module id = xUFz
// module chunks = 0